import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_VAPID_PUBLIC_KEY: z.string().default(''),
});

const parsed = schema.safeParse(import.meta.env);

/** Public, build-time configuration. Never contains server secrets. */
export const env = parsed.success
  ? parsed.data
  : { VITE_SUPABASE_URL: '', VITE_SUPABASE_ANON_KEY: '', VITE_VAPID_PUBLIC_KEY: '' };

export const envError = parsed.success ? null : 'Приложение не настроено: нет VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY.';
